export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-10">
          联系我们
        </h2>
        <div className="max-w-3xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/70">
            <div className="text-center mb-8">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto">
                如果您有任何关于羞羞歪歪漫画的问题、建议或合作意向，欢迎通过以下方式与我们联系。我们珍视每一位读者的反馈，共同打造更好的漫画阅读平台。
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="flex flex-col items-center p-5 rounded-xl hover:bg-background-50 transition-colors cursor-pointer">
                <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-3">
                  <i className="ri-mail-line text-xl text-primary-500"></i>
                </div>
                <h4 className="text-sm font-medium text-foreground-900 mb-1 whitespace-nowrap">投稿邮箱</h4>
                <p className="text-xs text-foreground-500">submit@xiuxiuwaiwai.com</p>
              </div>
              <div className="flex flex-col items-center p-5 rounded-xl hover:bg-background-50 transition-colors cursor-pointer">
                <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-3">
                  <i className="ri-customer-service-2-line text-xl text-accent-500"></i>
                </div>
                <h4 className="text-sm font-medium text-foreground-900 mb-1 whitespace-nowrap">在线客服</h4>
                <p className="text-xs text-foreground-500">工作日 9:00-18:00</p>
              </div>
              <div className="flex flex-col items-center p-5 rounded-xl hover:bg-background-50 transition-colors cursor-pointer">
                <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center mb-3">
                  <i className="ri-group-line text-xl text-secondary-500"></i>
                </div>
                <h4 className="text-sm font-medium text-foreground-900 mb-1 whitespace-nowrap">商务合作</h4>
                <p className="text-xs text-foreground-500">bd@xiuxiuwaiwai.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}